import { createFileRoute } from "@tanstack/react-router";
import { usePageTitle } from "@/hooks/use-page-title";
import { AlertCircle } from "lucide-react";
import { usePublicTranscript } from "@/lib/api/tickets";
import { TicketTranscriptView } from "@/components/tickets/ticket-transcript";
import { GlobalLoader } from "@/components/ui/global-loader";

export const Route = createFileRoute("/transcripts/$transcriptId")({
  component: TranscriptPage,
});

function TranscriptPage() {
  usePageTitle("Transcript");
  const { transcriptId } = Route.useParams();
  const { data, isPending, error } = usePublicTranscript(transcriptId);

  if (isPending) {
    return (
      <div className="bg-background flex min-h-dvh flex-col">
        <header className="border-border/40 border-b">
          <div className="mx-auto flex max-w-4xl items-center gap-3 px-4 py-4">
            <img src="/BLDR.png" alt="BLDR" className="size-8 rounded-lg" />
            <span className="text-lg font-bold text-rose-500 dark:text-rose-400">
              BLDR
            </span>
            <span className="text-border text-lg font-light">/</span>
            <span className="text-foreground text-sm font-medium">
              Ticket Transcript
            </span>
          </div>
        </header>
        <GlobalLoader message="Loading transcript..." />
      </div>
    );
  }

  if (error || !data?.data) {
    return (
      <div className="bg-background flex min-h-dvh flex-col">
        <header className="border-border/40 border-b">
          <div className="mx-auto flex max-w-4xl items-center gap-3 px-4 py-4">
            <img src="/BLDR.png" alt="BLDR" className="size-8 rounded-lg" />
            <span className="text-lg font-bold text-rose-500 dark:text-rose-400">
              BLDR
            </span>
            <span className="text-border text-lg font-light">/</span>
            <span className="text-foreground text-sm font-medium">
              Ticket Transcript
            </span>
          </div>
        </header>
        <div className="flex flex-1 items-center justify-center p-4">
          <div className="flex max-w-md flex-col items-center gap-4 text-center">
            <div className="bg-destructive/10 flex size-14 items-center justify-center rounded-full">
              <AlertCircle className="text-destructive size-7" />
            </div>
            <h1 className="text-foreground text-balance text-xl font-semibold">
              Transcript not found
            </h1>
            <p className="text-muted-foreground text-pretty text-sm">
              This transcript may have been deleted or the link is invalid.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-background min-h-dvh">
      <header className="border-border/40 border-b">
        <div className="mx-auto flex max-w-4xl items-center gap-3 px-4 py-4">
          <img src="/BLDR.png" alt="BLDR" className="size-8 rounded-lg" />
          <span className="text-lg font-bold text-rose-500 dark:text-rose-400">
            BLDR
          </span>
          <span className="text-border text-lg font-light">/</span>
          <span className="text-foreground text-sm font-medium">
            Ticket Transcript
          </span>
        </div>
      </header>
      <main className="px-4 py-6">
        <TicketTranscriptView transcript={data.data} />
      </main>
    </div>
  );
}
